module.exports = __webpack_public_path__ + "static/media/google.ea3f0a68.svg";